import type { LanguageCode } from '@/constants/languages';
import { resolveIntlLocale } from '@/utils/locale';

export function formatCurrency(amount: number, currencyISO: string, languageCode?: LanguageCode): string {
  const locale = resolveIntlLocale(languageCode);

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyISO,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}
